import React from 'react';
import { FaBuilding, FaIndustry, FaWarehouse, FaTruck } from 'react-icons/fa';

function IndustrialEstates() {
  return (
    <section className="py-16 bg-black text-white">
      <div className="w-full mx-auto text-center">
        {/* Hero Section */}
        <div className="bg-cover bg-center h-[600px] rounded-lg relative" style={{ backgroundImage: "url('images/construction.png')" }}>
          <div className="absolute inset-0 bg-black opacity-40"></div>
          <div className="relative z-10 flex flex-col items-center justify-center text-center h-full">
            <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold tracking-tight">Industrial Estates</h1>
            <p className="text-lg mt-4 text-gray-300">Modern industrial spaces designed for your business needs.</p>
          </div>
        </div>
 {/* Why Choose Us Section */}
 <section className="py-16 bg-white px-4">
          <h2 className="text-2xl md:text-4xl font-thin mb-12 text-center text-black">Why Choose Our Industrial Estates?</h2>
          <div className="max-w-3xl mx-auto  text-justify text-black">
            <p className="mb-6 text-lg font-thin">
              Our industrial estates are designed to cater to the diverse needs of businesses, from manufacturing to logistics. With flexible spaces and top-tier facilities, we provide an ideal environment for your business to grow and thrive.
            </p>
            <p className="mb-6 text-lg font-thin">
              Whether you're looking for a production unit, warehouse, or office space, our estates offer tailored solutions to meet your specific requirements. The combination of prime locations, modern infrastructure, and easy access makes us the best choice for your industrial needs.
            </p>
          </div>
        </section>
        {/* Key Features Section */}
        <section className="2xl:py-16 bg-white px-3">
          <h2 className="text-3xl font-thin mb-12 text-center text-black">Key Features</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="flex flex-col items-center text-center">
              <div className="text-5xl text-black mb-4">
                <FaBuilding />
              </div>
              <h3 className=" font-thin mb-2 text-2xl text-black ">Prime Locations</h3>
              <p className="text-gray-600 font-thin">Strategically located industrial estates in key commercial zones.</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="text-5xl text-black mb-4">
                <FaIndustry />
              </div>
              <h3 className=" font-thin mb-2 text-2xl text-black ">State-of-the-art Infrastructure</h3>
              <p className="text-gray-600 font-thin">High-quality buildings with modern amenities and utilities.</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="text-5xl text-black mb-4">
                <FaWarehouse />
              </div>
              <h3 className="text-2xl text-black  font-thin mb-2">Ample Storage</h3>
              <p className="text-gray-600 font-thin">Spacious warehouses to support logistics and storage needs.</p>
            </div>
            <div className="flex flex-col items-center text-center">
              <div className="text-5xl text-black mb-4">
                <FaTruck />
              </div>
              <h3 className=" font-thin mb-2 text-2xl text-black ">Easy Access</h3>
              <p className="text-gray-600 font-thin">Well-connected to major highways for seamless transport and logistics.</p>
            </div>
          </div>
        </section>

       

        {/* Courier Services Section */}
        <section className=" pt-10 xl:py-12 px-4 bg-white">
          <h2 className=" text-2xl md:text-4xl font-thin  text-center text-black">Our Courier Services</h2>
          <div className="max-w-4xl mx-auto text-black space-y-8">
            <div>
              <h3 className="text-2xl font-thin text-white mb-4">Reliable and Timely Deliveries</h3>
              <p className='text-lg font-thin text-justify'>
                At 1UKLogistics, we understand the critical importance of timely deliveries for businesses operating within industrial estates. Whether you need to transport raw materials, important documents, our reliable courier services ensure your shipments reach their destination on time, every time. We have built a strong reputation for our punctuality and adherence to delivery schedules, allowing businesses to maintain smooth operations and meet their customer demands without delays.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-thin text-white mb-4">Comprehensive Coverage</h3>
              <p className='text-lg text-justify font-thin'>
                With a vast network of couriers and delivery vehicles strategically positioned throughout the UK, 1UKLogistics offers comprehensive coverage for industrial estates across the country. We have established strong partnerships with local businesses, allowing us to efficiently serve both urban and rural areas. Our extensive reach ensures that your shipments can be picked up and delivered from anywhere within the industrial estates, no matter how remote the location.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-thin text-white mb-4">Tailored Logistics Solutions</h3>
              <p className='text-lg text-justify font-thin'>
                At 1UKLogistics, we recognise that every business has unique logistical needs. That's why we provide customised solutions to meet the specific requirements of your operations. Our team of logistics experts works closely with you to understand your business objectives, challenges, and constraints. We then design a tailored logistics strategy that optimises efficiency, minimises costs, and maximises the overall effectiveness of your supply chain within the industrial estate.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-thin text-white mb-4">Commitment to Sustainability</h3>
              <p className='text-lg text-justify font-thin'>
                As part of our commitment to environmental responsibility, 1UKLogistics embraces sustainable practices throughout our operations. We prioritise the use of fuel-efficient vehicles and constantly explore innovative solutions to minimise our carbon footprint. By partnering with us, businesses can align their logistics strategy with eco-friendly principles and contribute to a greener future.
              </p>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default IndustrialEstates;
